import React from 'react';
import { IndexRoute, Route } from 'react-router';
import Partners from './partners';

export default (
  <Route path="parceiros">
    <IndexRoute component={props => <Partners {...props} />} />
  </Route>
);
